import { COUNTRIES } from '../../constants/country';
import { getCurrentCountry } from '../../utils/country';

export const ZIP_CODE_VALIDATION = {
  [COUNTRIES.FR]: {
    regex: /^\d{5}$/,
    webConfig: {
      mask: [/\d/, /\d/, /\d/, /\d/, /\d/],
      mode: 'numeric',
      type: 'tel',
    },
    mobileConfig: {
      mask: '99999',
      keyboardType: 'numeric',
      type: 'tel',
    },
  },
  [COUNTRIES.GB]: {
    /*
     * https://stackoverflow.com/a/51885364/13544489
     * https://en.wikipedia.org/wiki/Postcodes_in_the_United_Kingdom#Formatting
     */
    regex: /^([A-Z]{1,2}\d[A-Z\d]? ?\d[A-Z]{2})$/,
    webConfig: {
      mask: undefined,
      mode: undefined,
      type: 'text',
    },
    mobileConfig: {
      mask: undefined,
      keyboardType: 'default',
      type: 'text',
    },
  },
};

const getLocaleZipCodeValidation = () => ZIP_CODE_VALIDATION[getCurrentCountry()];

export const getZipCodeWebConfig = () => getLocaleZipCodeValidation().webConfig;
export const getZipCodeMobileConfig = () => getLocaleZipCodeValidation().mobileConfig;

export const validateZipCode = (value?: string) => (value ? getLocaleZipCodeValidation().regex.test(value) : false);
